import React, { useEffect, useState } from 'react';
import { fetchClientDetailsFromDb, fetchFieldsFromDb } from '../history.service';
import { useStoreState } from 'easy-peasy';
import ActionButtons from './action-buttons/ActionButtons';
import StatusDetails from './StatusDetails';
import ClientIcon from './ClientIcon';
import ActivityDetails from './ActivityDetails';

const HistoryItem = ({ historyItem }) => {
  const user = useStoreState((state) => state.user);
  const clientId = user.uid;
  const orgId = user.orgId;
  const [missingMandatory, setMissingMandatory] = useState(false);
  const [intakeTasks, setIntakeTasks] = useState(false);

  useEffect(() => {
    const checkMandatoryFields = async () => {
      try {
        const clientDetails = await fetchClientDetailsFromDb(clientId);
        const fields = await fetchFieldsFromDb(orgId);
        if (fields.length) {
          setIntakeTasks(true);
        }
        const missingField = fields.some((field) => field.mandatory && !clientDetails[field.id]);
        setMissingMandatory(missingField);
      } catch (error) {
        setIntakeTasks(false);
        console.error('Error checking mandatory fields:', error);
      }
    };

    checkMandatoryFields();
  }, [clientId, orgId]);

  return (
    <div className="flex-container text--sm  outer-container margin-top--md ">
      <div className="icon-div">
        <ClientIcon status={historyItem?.status} clientEmail={historyItem?.client_email} />
      </div>
      <div className="activity-div inner-div">
        <ActivityDetails historyItem={historyItem} />
      </div>
      <div className="status-div inner-div">
        <StatusDetails historyItem={historyItem} />
      </div>
      <div className="actions-div inner-div">
        <ActionButtons
          historyItem={historyItem}
          missingMandatory={missingMandatory}
          intakeTasks={intakeTasks}
        />
      </div>
      <style jsx>
        {`
          .outer-container {
            border-bottom: 1px solid var(--border-gray);
            padding-bottom: 10px;
            justify-content: space-between;
          }
          .icon-div {
            width: 4%;
          }
          .activity-div {
            width: 25%;
            overflow: hidden;
          }
          .status-div {
            width: 35%;
          }
          .actions-div {
            width: 25%;
          }
          .inner-div {
            color: var(--gray-darkest);
          }
          @media only screen and (max-width: 900px) {
            .activity-div {
              width: 40% !important;
            }
            .source-div {
              display: none;
            }
            .status-div {
              display: none;
            }
            .actions-div {
              width: 42% !important;
            }
          }
          @media only screen and (max-width: 350px) {
            .icon-div {
              display: none;
            }
            .actions-div {
              width: 54% !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default HistoryItem;
